module.exports = __webpack_public_path__ + "static/img/product_mashine1.cb8fc96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/product_mashine1.png
// module id = gEAX
// module chunks = 1